import './QuoteDetailSummarySkeleton.scss';

/** Skeleton de carga para el resumen de la cotización */
const QuoteDetailSummarySkeleton = () => {
  return (
    <div className="quoteDetailSummarySkeleton">
      <div className="summaryHeader">
        <div className="iconSkeleton animationLoader" />
        <div className="titleSkeleton animationLoader" />
      </div>
      <div className="summaryCardsContainer">
        <div className="summaryCard">
          <div className="summaryRow">
            <div className="labelSkeleton animationLoader" />
            <div className="valueBoldSkeleton animationLoader" />
          </div>
          <div className="summaryDivider" />
          <div className="summaryRow">
            <div className="dotLabelSkeleton">
              <div className="dotSkeleton animationLoader" />
              <div className="labelSkeleton animationLoader" />
            </div>
            <div className="valueSkeleton animationLoader" />
          </div>
          <div className="summaryRow">
            <div className="dotLabelSkeleton">
              <div className="dotSkeleton animationLoader" />
              <div className="labelSkeleton animationLoader" />
            </div>
            <div className="valueSkeleton animationLoader" />
          </div>
        </div>
        <div className="summaryCardsDivider" />
        <div className="summaryCard">
          <div className="summaryRow">
            <div className="dotLabelSkeleton">
              <div className="dotSkeleton animationLoader" />
              <div className="labelSkeleton animationLoader" />
            </div>
            <div className="valueBoldSkeleton animationLoader" />
          </div>
          <div className="summaryDivider" />
          <div className="summaryRow">
            <div className="labelSkeleton animationLoader" />
            <div className="valueBoldSkeleton animationLoader" />
          </div>
          <div className="summaryRow">
            <div className="labelSkeleton animationLoader" />
            <div className="valueBoldSkeleton animationLoader" />
          </div>
        </div>
      </div>
      <div className="downloadBtnSkeleton animationLoader" />
    </div>
  );
};

export default QuoteDetailSummarySkeleton;
